import S from "../styles/styles";
import { Logo, Field, Divider } from "./UI";

const AuthPage = ({
  authMode, setAuthMode,
  authRole, setAuthRole,
  authError,
  loginForm,  setLoginForm,
  signupForm, setSignupForm,
  properties,
  onLogin, onSignup,
  onForgotPassword,
  onBack,
}) => (
  <div style={S.body}>
    <div style={S.authWrap}>
      <div style={S.authCard}>
        <div style={{ marginBottom: 24, cursor: "pointer", color: "#9993A8", fontSize: 13 }} onClick={onBack}>
          ← Back
        </div>
        <Logo />

        <div style={{ ...S.tabRow, marginTop: 24 }}>
          <button style={{ ...S.tabBtn, ...(authMode === "login" ? S.tabBtnActive : {}) }} onClick={() => setAuthMode("login")}>
            Sign In
          </button>
          {authRole === "renter" && (
            <button style={{ ...S.tabBtn, ...(authMode === "signup" ? S.tabBtnActive : {}) }} onClick={() => setAuthMode("signup")}>
              Create Account
            </button>
          )}
        </div>

        <div style={S.roleGrid}>
          {[{ id:"manager", icon:"🏢", label:"Property Manager" },{ id:"renter", icon:"🏠", label:"Renter" }].map((r) => (
            <div key={r.id} style={{ ...S.roleCard, ...(authRole === r.id ? S.roleCardActive : {}) }} onClick={() => {
              setAuthRole(r.id);
              // Manager signup is disabled -- force login mode
              if (r.id === "manager" && authMode === "signup") setAuthMode("login");
            }}>
              <div style={{ fontSize: 28, marginBottom: 6 }}>{r.icon}</div>
              <div style={{ fontSize: 13, fontWeight: 600 }}>{r.label}</div>
            </div>
          ))}
        </div>

        {authError && <div style={S.errorBox}>⚠ {authError}</div>}

        {/* SIGNUP -- renter only */}
        {authMode === "signup" && authRole === "renter" && <>
          <Field label="Full Name">
            <input style={S.input} placeholder="Your full name" value={signupForm.name} onChange={(e) => setSignupForm((p) => ({ ...p, name: e.target.value }))} />
          </Field>
          <Field label="Email Address">
            <input style={S.input} placeholder="you@email.com" value={signupForm.email} onChange={(e) => setSignupForm((p) => ({ ...p, email: e.target.value }))} />
          </Field>
          {authRole === "manager" && (
            <Field label="Company / Portfolio Name">
              <input style={S.input} placeholder="e.g. My Property Group" value={signupForm.companyName} onChange={(e) => setSignupForm((p) => ({ ...p, companyName: e.target.value }))} />
            </Field>
          )}
          {authRole === "renter" && <>
            <Field label="Property Registration Code">
              <input
                style={S.input}
                placeholder="Enter code from your manager e.g. PROP-4801"
                value={signupForm.regCode || ""}
                onChange={(e) => setSignupForm((p) => ({ ...p, regCode: e.target.value.toUpperCase() }))}
              />
            </Field>
            <div style={{ ...S.infoBanner, marginBottom: 16 }}>
              <span>ℹ️</span>
              <span style={{ fontSize: 12 }}>Your registration code is provided by your property manager. It links you to your building privately.</span>
            </div>
            <Field label="Unit Number">
              <input style={S.input} placeholder="e.g. 3, 4B" value={signupForm.unit} onChange={(e) => setSignupForm((p) => ({ ...p, unit: e.target.value }))} />
            </Field>
          </>}
          <Field label="Password">
            <input style={S.input} type="password" placeholder="At least 6 characters" value={signupForm.password} onChange={(e) => setSignupForm((p) => ({ ...p, password: e.target.value }))} />
          </Field>
          <Field label="Confirm Password">
            <input style={S.input} type="password" placeholder="Repeat your password" value={signupForm.confirm} onChange={(e) => setSignupForm((p) => ({ ...p, confirm: e.target.value }))} />
          </Field>
          <button style={{ ...S.btnPrimary, width: "100%", marginTop: 4 }} onClick={onSignup}>
            Create {authRole === "manager" ? "Manager" : "Renter"} Account →
          </button>
          <Divider label="or" />
          <button style={{ ...S.btnGhost, width: "100%", textAlign: "center" }} onClick={() => setAuthMode("login")}>
            Already have an account? <span style={{ color: "#E8622A" }}>Sign in</span>
          </button>
        </>}

        {/* ── LOGIN ── */}
        {authMode === "login" && <>
          <Field label="Email Address">
            <input style={S.input} placeholder="you@email.com" value={loginForm.email} onChange={(e) => setLoginForm((p) => ({ ...p, email: e.target.value }))} />
          </Field>
          <Field label="Password">
            <input
              style={S.input}
              type="password"
              placeholder="Your password"
              value={loginForm.password}
              onChange={(e) => setLoginForm((p) => ({ ...p, password: e.target.value }))}
              onKeyDown={(e) => e.key === "Enter" && onLogin()}
            />
          </Field>

          {/* Forgot password link */}
          <div style={{ textAlign: "right", marginTop: -8, marginBottom: 16 }}>
            <button style={{ ...S.btnGhost, fontSize: 12, color: "#E8622A" }} onClick={onForgotPassword}>
              Forgot password?
            </button>
          </div>

          <button style={{ ...S.btnPrimary, width: "100%" }} onClick={onLogin}>
            Sign In as {authRole === "manager" ? "Manager" : "Renter"} →
          </button>

          <Divider label="or" />
          {authRole === "renter" && (
            <button style={{ ...S.btnGhost, width: "100%", textAlign: "center" }} onClick={() => setAuthMode("signup")}>
              New here? <span style={{ color: "#E8622A" }}>Create an account</span>
            </button>
          )}
        </>}
      </div>
    </div>
  </div>
);

export default AuthPage;
